<script>
import i18n from '@/plugins/i18n';

export default {
    props: [
        'value',
        'options',
        'identifier_key',
        'identifier_name',
        'disabled'
    ],

    data() {
        return {
            is_active: false,
            keyword: '',
            hovered_item: null,
        }
    },

    computed: {
        selected_item_name() {
            if (this.value === null || this.value === undefined) {
                return i18n.t('misc.make_selection');
            } else {
                const item = this.options.find(x => x[this.identifier_key] == this.value);
                if (item) return item[this.identifier_name];
                else return i18n.t('misc.no_options');
            }
        },

        filtered_options() {
            if (this.keyword === '') {
                return this.options;
            } else {
                return this.options.filter(x => String(x[this.identifier_name]).toLowerCase().includes(String(this.keyword).toLowerCase()));
            }
        },

        options_exist() {
            return this.filtered_options != null && this.filtered_options != undefined && this.filtered_options.length != 0;
        },
    },

    methods: {
        SetActive(bool) {
            if (bool === null) {
                this.is_active = !this.is_active;
            } else {
                this.is_active = bool;
            }

            if (this.is_active === true) {
                setTimeout(() => {
                    const el = window.document.getElementById('search-field');
                    if (el) el.focus();
                }, 25);
            }
        },

        SelectOption(item) {
            this.SetActive(false);
            this.$emit('input', item[this.identifier_key]);
        },

        HandleKeyDown(e) {
            if (!this.is_active || !this.options_exist) return;

            if (e.code === 'ArrowDown') {
                this.GoDown();
            } else if (e.code === 'ArrowUp') {
                this.GoUp();
            } else if (e.code === 'Enter' && this.hovered_item != null) {
                this.SelectOption(this.hovered_item);
            }
        },

        GoDown() {
            if (!this.hovered_item) {
                this.SetHoveredItem(this.filtered_options[0], true);
            } else {
                const idx = this.filtered_options.findIndex(x => x[this.identifier_key] == this.hovered_item[this.identifier_key]);
                if (idx === this.filtered_options.length -1) {
                    this.SetHoveredItem(this.filtered_options[0], true);
                } else {
                    this.SetHoveredItem(this.filtered_options[idx+1], true);
                }
            }
        },
        
        GoUp() {
            if (!this.hovered_item) {
                this.SetHoveredItem(this.filtered_options[this.filtered_options.length -1], true);
            } else {
                const idx = this.filtered_options.findIndex(x => x[this.identifier_key] == this.hovered_item[this.identifier_key]);
                if (idx === 0) {
                    this.SetHoveredItem(this.filtered_options[this.filtered_options.length -1], true);
                } else {
                    this.SetHoveredItem(this.filtered_options[idx-1], true);
                }
            }
        },

        SetHoveredItem(item, is_from_key) {
            this.hovered_item = item;
            this.ScrollToHoveredItem(item, is_from_key);
        },

        IsHoveredItem(item) {
            if (!this.hovered_item)
                return false;

            return this.hovered_item[this.identifier_key] == item[this.identifier_key]
        },

        ScrollToHoveredItem(item, is_from_key) {
            if (!is_from_key) return;

            const container = document.getElementById('options');
            const el = document.getElementById(`option_${item[this.identifier_key]}`);
            container.scrollTop = el.offsetTop;
        },

        HandleOptionKeyup(e) {
            console.log(e);
        },
    },
}
</script>

<template>
    <div class="sust-select-field" @keydown="HandleKeyDown($event)">
        <button v-show="!is_active" @click="SetActive(null)" :disabled="disabled">
            {{ selected_item_name }}
        </button>

        <div v-if="is_active" id="options">
            <input type="text" id="search-field" v-model="keyword" :placeholder="$t('misc.search_for_keyword')" autocomplete="off">
            <button v-for="option in filtered_options" :key="option[identifier_key]" @click="SelectOption(option)"
                @mouseover="SetHoveredItem(option, false)" @mouseleave="SetHoveredItem(null, false)"
                :class="{
                    'selected-option': option[identifier_key] == value,
                    'hovered-option': IsHoveredItem(option)
                }"
                :id="`option_${option[identifier_key]}`"
            >
                {{ option[identifier_name] }}
            </button>
            
            <button v-if="!options_exist" class="no-options-text" @click="() => keyword = ''">
                {{ $t('misc.no_options') }}
            </button>
        </div>

    </div>
</template>

<style lang='scss' scoped>
    .sust-select-field {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        position: relative;

        background-color: transparent !important;

        > button {
            &:focus {
                outline: .15em solid var(--sustainfinity-blue);
                box-shadow: .0 .1em .25em .05em var(--sustainfinity-blue);
            }
        }

        > div {
            position: absolute;
            width: 100%;
            max-height: 250px !important;
            overflow-y: auto;
            overflow-x: hidden;

            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            border-radius: .25em;
            outline: thin solid gray;
            box-shadow: 0 .1em .25em .1em lightgray;

            > button {
                border-radius: 0 !important;
            }
        }
    }

    input, button {
        background-color: rgb(255, 255, 255);
        width: 100%;
        border: 0 !important;
        outline: thin solid gray;
        padding: .3em;
        border-radius: .5em;
        text-align: left;
        
        &:disabled {
            background-color: lightgray !important;
            pointer-events: none;
        }
    }

    input {
        border-radius: 0 !important;
        &:hover {
            background-color: white !important;
        }
    }

    .selected-option {
        background-color: rgb(200, 200, 200);
    }

    .hovered-option {
        background-color: rgb(230, 230, 230);
    }

    .no-options-text {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        text-align: center; 
        
        padding: .25em 0; 
        font-weight: 100; 
        font-size: .75vw; 
    }
</style>